var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowing && _vm.selectedAd != null
    ? _c(
        "div",
        { style: _vm.componentStyle },
        [_c(_vm.selectedAd.component, { tag: "component" })],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }